// extracted by mini-css-extract-plugin
export var locationCard = "_pv-0";